var _rect, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 602,
    height: 219,
    viewBox: "0 0 602 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "antimetal-spots",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3142_36165)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3142_36165",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -7,
    width: 602,
    height: 210,
    style: {
      maskType: "alpha"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3142_36165",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -7,
    width: 602,
    height: 235,
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -6.84082,
    width: 602,
    height: 233.959,
    fill: "url(#paint0_linear_3142_36165)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3142_36165)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -6.84082,
    width: 602,
    height: 209.332,
    fill: "url(#paint1_linear_3142_36165)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3142_36165)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 34.2051 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 41.0459 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 47.8867 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 82.0918 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 95.7734 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 102.614 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 123.137 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 129.978 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 136.818 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 143.659 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 150.501 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 157.342 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 164.183 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 171.023 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 177.864 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.389,
    cy: 28.0477,
    r: 0.684091,
    transform: "rotate(180 185.389 28.0477)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.593,
    cy: 28.0477,
    r: 0.684091,
    transform: "rotate(180 219.593 28.0477)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.435,
    cy: 28.0477,
    r: 0.684091,
    transform: "rotate(180 226.435 28.0477)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.276,
    cy: 28.0477,
    r: 0.684091,
    transform: "rotate(180 233.276 28.0477)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.117,
    cy: 28.0477,
    r: 0.684091,
    transform: "rotate(180 240.117 28.0477)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.48,
    cy: 28.0477,
    r: 0.684091,
    transform: "rotate(180 267.48 28.0477)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.162,
    cy: 28.0477,
    r: 0.684091,
    transform: "rotate(180 281.162 28.0477)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.843,
    cy: 28.0477,
    r: 0.684091,
    transform: "rotate(180 294.843 28.0477)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.685,
    cy: 28.0477,
    r: 0.684091,
    transform: "rotate(180 301.685 28.0477)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 307.842 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 321.523 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 328.364 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 342.046 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 355.728 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 369.409 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 376.251 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 389.933 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 410.455 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 417.296 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 430.978 28.7318)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.389,
    cy: 28.0477,
    r: 0.684091,
    transform: "rotate(180 486.389 28.0477)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 493.23,
    cy: 28.0477,
    r: 0.684091,
    transform: "rotate(180 493.23 28.0477)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500.071,
    cy: 28.0477,
    r: 0.684091,
    transform: "rotate(180 500.071 28.0477)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.958,
    cy: 28.0477,
    r: 0.684091,
    transform: "rotate(180 547.958 28.0477)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 568.48,
    cy: 28.0477,
    r: 0.684091,
    transform: "rotate(180 568.48 28.0477)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.8892,
    cy: 34.8887,
    r: 0.684091,
    transform: "rotate(180 34.8892 34.8887)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5708,
    cy: 34.8887,
    r: 0.684091,
    transform: "rotate(180 48.5708 34.8887)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.7759,
    cy: 34.8887,
    r: 0.684091,
    transform: "rotate(180 82.7759 34.8887)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.6167,
    cy: 34.8887,
    r: 0.684091,
    transform: "rotate(180 89.6167 34.8887)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 95.7734 35.5728)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 102.614 35.5728)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 123.137 35.5728)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 143.659 35.5728)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 157.342 35.5728)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.389,
    cy: 34.8887,
    r: 0.684091,
    transform: "rotate(180 185.389 34.8887)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.23,
    cy: 34.8887,
    r: 0.684091,
    transform: "rotate(180 192.23 34.8887)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.071,
    cy: 34.8887,
    r: 0.684091,
    transform: "rotate(180 199.071 34.8887)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.752,
    cy: 34.8887,
    r: 0.684091,
    transform: "rotate(180 212.752 34.8887)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.435,
    cy: 34.8887,
    r: 0.684091,
    transform: "rotate(180 226.435 34.8887)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.276,
    cy: 34.8887,
    r: 0.684091,
    transform: "rotate(180 233.276 34.8887)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.48,
    cy: 34.8887,
    r: 0.684091,
    transform: "rotate(180 267.48 34.8887)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.162,
    cy: 34.8887,
    r: 0.684091,
    transform: "rotate(180 281.162 34.8887)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.843,
    cy: 34.8887,
    r: 0.684091,
    transform: "rotate(180 294.843 34.8887)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 314.683 35.5728)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 342.046 35.5728)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 348.887 35.5728)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 355.728 35.5728)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 362.568 35.5728)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 396.773 35.5728)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 444.659 35.5728)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 451.501 35.5728)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 458.342 35.5728)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 465.183 35.5728)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 472.023 35.5728)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506.912,
    cy: 34.8887,
    r: 0.684091,
    transform: "rotate(180 506.912 34.8887)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 513.752,
    cy: 34.8887,
    r: 0.684091,
    transform: "rotate(180 513.752 34.8887)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 34.2051 42.4137)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 41.0459 42.4137)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 109.455 42.4137)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 123.137 42.4137)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.071,
    cy: 41.7296,
    r: 0.684091,
    transform: "rotate(180 199.071 41.7296)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.912,
    cy: 41.7296,
    r: 0.684091,
    transform: "rotate(180 205.912 41.7296)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.752,
    cy: 41.7296,
    r: 0.684091,
    transform: "rotate(180 212.752 41.7296)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.593,
    cy: 41.7296,
    r: 0.684091,
    transform: "rotate(180 219.593 41.7296)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.435,
    cy: 41.7296,
    r: 0.684091,
    transform: "rotate(180 226.435 41.7296)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.48,
    cy: 41.7296,
    r: 0.684091,
    transform: "rotate(180 267.48 41.7296)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 280.478 42.4137)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 294.159 42.4137)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 314.683 42.4137)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 328.364 42.4137)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 335.205 42.4137)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 342.046 42.4137)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 348.887 42.4137)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 355.728 42.4137)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 362.568 42.4137)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.617,
    cy: 41.7296,
    r: 0.684091,
    transform: "rotate(180 390.617 41.7296)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.298,
    cy: 41.7296,
    r: 0.684091,
    transform: "rotate(180 404.298 41.7296)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.98,
    cy: 41.7296,
    r: 0.684091,
    transform: "rotate(180 417.98 41.7296)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.821,
    cy: 41.7296,
    r: 0.684091,
    transform: "rotate(180 424.821 41.7296)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.708,
    cy: 41.7296,
    r: 0.684091,
    transform: "rotate(180 472.708 41.7296)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 479.548,
    cy: 41.7296,
    r: 0.684091,
    transform: "rotate(180 479.548 41.7296)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 513.068 42.4137)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 540.433 42.4137)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 547.273 42.4137)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 560.955 42.4137)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 568.48,
    cy: 41.7296,
    r: 0.684091,
    transform: "rotate(180 568.48 41.7296)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.73,
    cy: 48.5704,
    r: 0.684091,
    transform: "rotate(180 41.73 48.5704)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.4116,
    cy: 48.5704,
    r: 0.684091,
    transform: "rotate(180 55.4116 48.5704)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.98,
    cy: 48.5704,
    r: 0.684091,
    transform: "rotate(180 116.98 48.5704)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.502,
    cy: 48.5704,
    r: 0.684091,
    transform: "rotate(180 137.502 48.5704)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.026,
    cy: 48.5704,
    r: 0.684091,
    transform: "rotate(180 158.026 48.5704)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.389,
    cy: 48.5704,
    r: 0.684091,
    transform: "rotate(180 185.389 48.5704)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 205.228 49.2545)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 212.068 49.2545)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 225.751 49.2545)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.093,
    cy: 48.5704,
    r: 0.684091,
    transform: "rotate(180 370.093 48.5704)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 444.659 49.2545)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 472.023 49.2545)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 478.864 49.2545)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 492.546 49.2545)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 499.387 49.2545)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 560.955 49.2545)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 567.796 49.2545)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 54.7275 56.0955)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 205.228 56.0955)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 218.909 56.0955)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.935,
    cy: 55.4114,
    r: 0.684091,
    transform: "rotate(180 376.935 55.4114)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.458,
    cy: 55.4114,
    r: 0.684091,
    transform: "rotate(180 397.458 55.4114)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.821,
    cy: 55.4114,
    r: 0.684091,
    transform: "rotate(180 424.821 55.4114)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 526.751 56.0955)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 540.433 56.0955)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 547.273 56.0955)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 554.114 56.0955)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 567.796 56.0955)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 34.2051 62.9364)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 47.8867 62.9364)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 61.5684 62.9364)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 68.4092 62.9364)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 75.251 62.9364)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 88.9326 62.9364)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.708,
    cy: 62.2523,
    r: 0.684091,
    transform: "rotate(180 171.708 62.2523)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.548,
    cy: 62.2523,
    r: 0.684091,
    transform: "rotate(180 178.548 62.2523)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.071,
    cy: 62.2523,
    r: 0.684091,
    transform: "rotate(180 199.071 62.2523)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.912,
    cy: 62.2523,
    r: 0.684091,
    transform: "rotate(180 205.912 62.2523)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.752,
    cy: 62.2523,
    r: 0.684091,
    transform: "rotate(180 212.752 62.2523)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.435,
    cy: 62.2523,
    r: 0.684091,
    transform: "rotate(180 226.435 62.2523)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.935,
    cy: 62.2523,
    r: 0.684091,
    transform: "rotate(180 376.935 62.2523)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.776,
    cy: 62.2523,
    r: 0.684091,
    transform: "rotate(180 383.776 62.2523)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.617,
    cy: 62.2523,
    r: 0.684091,
    transform: "rotate(180 390.617 62.2523)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.458,
    cy: 62.2523,
    r: 0.684091,
    transform: "rotate(180 397.458 62.2523)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 519.909 62.9364)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 540.433 62.9364)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554.798,
    cy: 62.2523,
    r: 0.684091,
    transform: "rotate(180 554.798 62.2523)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.73,
    cy: 69.0932,
    r: 0.684091,
    transform: "rotate(180 41.73 69.0932)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5708,
    cy: 69.0932,
    r: 0.684091,
    transform: "rotate(180 48.5708 69.0932)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.4116,
    cy: 69.0932,
    r: 0.684091,
    transform: "rotate(180 55.4116 69.0932)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.9351,
    cy: 69.0932,
    r: 0.684091,
    transform: "rotate(180 75.9351 69.0932)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.7759,
    cy: 69.0932,
    r: 0.684091,
    transform: "rotate(180 82.7759 69.0932)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.6167,
    cy: 69.0932,
    r: 0.684091,
    transform: "rotate(180 89.6167 69.0932)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.4575,
    cy: 69.0932,
    r: 0.684091,
    transform: "rotate(180 96.4575 69.0932)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.298,
    cy: 69.0932,
    r: 0.684091,
    transform: "rotate(180 103.298 69.0932)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 123.137 69.7773)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 136.818 69.7773)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 157.342 69.7773)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 184.705 69.7773)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 191.546 69.7773)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 205.228 69.7773)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 225.751 69.7773)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 369.409 69.7773)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 376.251 69.7773)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 383.092 69.7773)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 389.933 69.7773)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 396.773 69.7773)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 403.614 69.7773)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.98,
    cy: 69.0932,
    r: 0.684091,
    transform: "rotate(180 417.98 69.0932)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.821,
    cy: 69.0932,
    r: 0.684091,
    transform: "rotate(180 424.821 69.0932)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.343,
    cy: 69.0932,
    r: 0.684091,
    transform: "rotate(180 445.343 69.0932)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 452.185,
    cy: 69.0932,
    r: 0.684091,
    transform: "rotate(180 452.185 69.0932)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 479.548,
    cy: 69.0932,
    r: 0.684091,
    transform: "rotate(180 479.548 69.0932)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 492.546 69.7773)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 499.387 69.7773)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 526.751 69.7773)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 533.592 69.7773)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 540.433 69.7773)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 547.273 69.7773)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 34.2051 76.6182)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 47.8867 76.6182)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 54.7275 76.6182)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 61.5684 76.6182)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.298,
    cy: 75.9341,
    r: 0.684091,
    transform: "rotate(180 103.298 75.9341)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.139,
    cy: 75.9341,
    r: 0.684091,
    transform: "rotate(180 110.139 75.9341)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.821,
    cy: 75.9341,
    r: 0.684091,
    transform: "rotate(180 123.821 75.9341)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.662,
    cy: 75.9341,
    r: 0.684091,
    transform: "rotate(180 130.662 75.9341)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.185,
    cy: 75.9341,
    r: 0.684091,
    transform: "rotate(180 151.185 75.9341)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.026,
    cy: 75.9341,
    r: 0.684091,
    transform: "rotate(180 158.026 75.9341)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.867,
    cy: 75.9341,
    r: 0.684091,
    transform: "rotate(180 164.867 75.9341)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.23,
    cy: 75.9341,
    r: 0.684091,
    transform: "rotate(180 192.23 75.9341)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 205.228 76.6182)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 225.751 76.6182)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.935,
    cy: 75.9341,
    r: 0.684091,
    transform: "rotate(180 376.935 75.9341)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.298,
    cy: 75.9341,
    r: 0.684091,
    transform: "rotate(180 404.298 75.9341)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 410.455 76.6182)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 444.659 76.6182)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 451.501 76.6182)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 458.342 76.6182)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 492.546 76.6182)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 519.909 76.6182)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 526.751 76.6182)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.958,
    cy: 75.9341,
    r: 0.684091,
    transform: "rotate(180 547.958 75.9341)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.639,
    cy: 75.9341,
    r: 0.684091,
    transform: "rotate(180 561.639 75.9341)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.8892,
    cy: 82.775,
    r: 0.684091,
    transform: "rotate(180 34.8892 82.775)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.73,
    cy: 82.775,
    r: 0.684091,
    transform: "rotate(180 41.73 82.775)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.4116,
    cy: 82.775,
    r: 0.684091,
    transform: "rotate(180 55.4116 82.775)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.2524,
    cy: 82.775,
    r: 0.684091,
    transform: "rotate(180 62.2524 82.775)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.0933,
    cy: 82.775,
    r: 0.684091,
    transform: "rotate(180 69.0933 82.775)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.9351,
    cy: 82.775,
    r: 0.684091,
    transform: "rotate(180 75.9351 82.775)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.4575,
    cy: 82.775,
    r: 0.684091,
    transform: "rotate(180 96.4575 82.775)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.821,
    cy: 82.775,
    r: 0.684091,
    transform: "rotate(180 123.821 82.775)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 129.978 83.4591)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 136.818 83.4591)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 164.183 83.4591)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 171.023 83.4591)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 191.546 83.4591)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 198.387 83.4591)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 225.751 83.4591)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 430.978 83.4591)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 437.818 83.4591)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 451.501 83.4591)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 465.183 83.4591)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 472.023 83.4591)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 478.864 83.4591)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 513.752,
    cy: 82.775,
    r: 0.684091,
    transform: "rotate(180 513.752 82.775)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520.593,
    cy: 82.775,
    r: 0.684091,
    transform: "rotate(180 520.593 82.775)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 527.435,
    cy: 82.775,
    r: 0.684091,
    transform: "rotate(180 527.435 82.775)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.8892,
    cy: 89.6159,
    r: 0.684091,
    transform: "rotate(180 34.8892 89.6159)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.4116,
    cy: 89.6159,
    r: 0.684091,
    transform: "rotate(180 55.4116 89.6159)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.9351,
    cy: 89.6159,
    r: 0.684091,
    transform: "rotate(180 75.9351 89.6159)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.821,
    cy: 89.6159,
    r: 0.684091,
    transform: "rotate(180 123.821 89.6159)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.343,
    cy: 89.6159,
    r: 0.684091,
    transform: "rotate(180 144.343 89.6159)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.026,
    cy: 89.6159,
    r: 0.684091,
    transform: "rotate(180 158.026 89.6159)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.708,
    cy: 89.6159,
    r: 0.684091,
    transform: "rotate(180 171.708 89.6159)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 218.909 90.3)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 232.592 90.3)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.935,
    cy: 89.6159,
    r: 0.684091,
    transform: "rotate(180 376.935 89.6159)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 430.978 90.3)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 444.659 90.3)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 451.501 90.3)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 458.342 90.3)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 465.183 90.3)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 478.864 90.3)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 485.705 90.3)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 492.546 90.3)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 499.387 90.3)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 519.909 90.3)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 526.751 90.3)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.639,
    cy: 89.6159,
    r: 0.684091,
    transform: "rotate(180 561.639 89.6159)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 568.48,
    cy: 89.6159,
    r: 0.684091,
    transform: "rotate(180 568.48 89.6159)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.73,
    cy: 96.4568,
    r: 0.684091,
    transform: "rotate(180 41.73 96.4568)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.4116,
    cy: 96.4568,
    r: 0.684091,
    transform: "rotate(180 55.4116 96.4568)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.2524,
    cy: 96.4568,
    r: 0.684091,
    transform: "rotate(180 62.2524 96.4568)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.0933,
    cy: 96.4568,
    r: 0.684091,
    transform: "rotate(180 69.0933 96.4568)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.9351,
    cy: 96.4568,
    r: 0.684091,
    transform: "rotate(180 75.9351 96.4568)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.7759,
    cy: 96.4568,
    r: 0.684091,
    transform: "rotate(180 82.7759 96.4568)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 164.183 97.1409)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 171.023 97.1409)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 177.864 97.1409)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 437.818 97.1409)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 444.659 97.1409)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 451.501 97.1409)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 458.342 97.1409)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 465.183 97.1409)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 472.023 97.1409)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 478.864 97.1409)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 499.387 97.1409)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 506.228 97.1409)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 534.276,
    cy: 96.4568,
    r: 0.684091,
    transform: "rotate(180 534.276 96.4568)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.639,
    cy: 96.4568,
    r: 0.684091,
    transform: "rotate(180 561.639 96.4568)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.4116,
    cy: 103.298,
    r: 0.684091,
    transform: "rotate(180 55.4116 103.298)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.0933,
    cy: 103.298,
    r: 0.684091,
    transform: "rotate(180 69.0933 103.298)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.7759,
    cy: 103.298,
    r: 0.684091,
    transform: "rotate(180 82.7759 103.298)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.6167,
    cy: 103.298,
    r: 0.684091,
    transform: "rotate(180 89.6167 103.298)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.4575,
    cy: 103.298,
    r: 0.684091,
    transform: "rotate(180 96.4575 103.298)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 129.978 103.982)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 136.818 103.982)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 150.501 103.982)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 157.342 103.982)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 164.183 103.982)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 171.023 103.982)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 191.546 103.982)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 417.296 103.982)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 424.137 103.982)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 444.659 103.982)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.026,
    cy: 103.298,
    r: 0.684091,
    transform: "rotate(180 459.026 103.298)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.867,
    cy: 103.298,
    r: 0.684091,
    transform: "rotate(180 465.867 103.298)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.708,
    cy: 103.298,
    r: 0.684091,
    transform: "rotate(180 472.708 103.298)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 479.548,
    cy: 103.298,
    r: 0.684091,
    transform: "rotate(180 479.548 103.298)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500.071,
    cy: 103.298,
    r: 0.684091,
    transform: "rotate(180 500.071 103.298)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 513.752,
    cy: 103.298,
    r: 0.684091,
    transform: "rotate(180 513.752 103.298)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520.593,
    cy: 103.298,
    r: 0.684091,
    transform: "rotate(180 520.593 103.298)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 534.276,
    cy: 103.298,
    r: 0.684091,
    transform: "rotate(180 534.276 103.298)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 541.117,
    cy: 103.298,
    r: 0.684091,
    transform: "rotate(180 541.117 103.298)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 568.48,
    cy: 103.298,
    r: 0.684091,
    transform: "rotate(180 568.48 103.298)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.8892,
    cy: 110.139,
    r: 0.684091,
    transform: "rotate(180 34.8892 110.139)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.4116,
    cy: 110.139,
    r: 0.684091,
    transform: "rotate(180 55.4116 110.139)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 68.4092 110.823)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 123.137 110.823)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 129.978 110.823)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 136.818 110.823)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.026,
    cy: 110.139,
    r: 0.684091,
    transform: "rotate(180 158.026 110.139)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.867,
    cy: 110.139,
    r: 0.684091,
    transform: "rotate(180 164.867 110.139)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.708,
    cy: 110.139,
    r: 0.684091,
    transform: "rotate(180 171.708 110.139)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.98,
    cy: 110.139,
    r: 0.684091,
    transform: "rotate(180 417.98 110.139)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.343,
    cy: 110.139,
    r: 0.684091,
    transform: "rotate(180 445.343 110.139)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.389,
    cy: 110.139,
    r: 0.684091,
    transform: "rotate(180 486.389 110.139)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 493.23,
    cy: 110.139,
    r: 0.684091,
    transform: "rotate(180 493.23 110.139)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 513.068 110.823)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 533.592 110.823)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 554.114 110.823)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 560.955 110.823)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 567.796 110.823)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 41.0459 117.664)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.2524,
    cy: 116.98,
    r: 0.684091,
    transform: "rotate(180 62.2524 116.98)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.0933,
    cy: 116.98,
    r: 0.684091,
    transform: "rotate(180 69.0933 116.98)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.9351,
    cy: 116.98,
    r: 0.684091,
    transform: "rotate(180 75.9351 116.98)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.7759,
    cy: 116.98,
    r: 0.684091,
    transform: "rotate(180 82.7759 116.98)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.298,
    cy: 116.98,
    r: 0.684091,
    transform: "rotate(180 103.298 116.98)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.98,
    cy: 116.98,
    r: 0.684091,
    transform: "rotate(180 116.98 116.98)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.662,
    cy: 116.98,
    r: 0.684091,
    transform: "rotate(180 130.662 116.98)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.502,
    cy: 116.98,
    r: 0.684091,
    transform: "rotate(180 137.502 116.98)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.185,
    cy: 116.98,
    r: 0.684091,
    transform: "rotate(180 151.185 116.98)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.026,
    cy: 116.98,
    r: 0.684091,
    transform: "rotate(180 158.026 116.98)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.867,
    cy: 116.98,
    r: 0.684091,
    transform: "rotate(180 164.867 116.98)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 198.387 117.664)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 205.228 117.664)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 212.068 117.664)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 218.909 117.664)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 232.592 117.664)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.458,
    cy: 116.98,
    r: 0.684091,
    transform: "rotate(180 397.458 116.98)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.298,
    cy: 116.98,
    r: 0.684091,
    transform: "rotate(180 404.298 116.98)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 437.818 117.664)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 458.342 117.664)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 465.183 117.664)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 478.864 117.664)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 485.705 117.664)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 492.546 117.664)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 499.387 117.664)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 506.228 117.664)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 519.909 117.664)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.958,
    cy: 116.98,
    r: 0.684091,
    transform: "rotate(180 547.958 116.98)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.639,
    cy: 116.98,
    r: 0.684091,
    transform: "rotate(180 561.639 116.98)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.8892,
    cy: 123.82,
    r: 0.684091,
    transform: "rotate(180 34.8892 123.82)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.73,
    cy: 123.82,
    r: 0.684091,
    transform: "rotate(180 41.73 123.82)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.7759,
    cy: 123.82,
    r: 0.684091,
    transform: "rotate(180 82.7759 123.82)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.4575,
    cy: 123.82,
    r: 0.684091,
    transform: "rotate(180 96.4575 123.82)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.298,
    cy: 123.82,
    r: 0.684091,
    transform: "rotate(180 103.298 123.82)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 143.659 124.505)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 157.342 124.505)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 191.546 124.505)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.912,
    cy: 123.82,
    r: 0.684091,
    transform: "rotate(180 205.912 123.82)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.593,
    cy: 123.82,
    r: 0.684091,
    transform: "rotate(180 219.593 123.82)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.435,
    cy: 123.82,
    r: 0.684091,
    transform: "rotate(180 226.435 123.82)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 369.409 124.505)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 376.251 124.505)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 383.092 124.505)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 396.773 124.505)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 403.614 124.505)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 410.455 124.505)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 437.818 124.505)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 444.659 124.505)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 472.023 124.505)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 478.864 124.505)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 492.546 124.505)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 499.387 124.505)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 527.435,
    cy: 123.82,
    r: 0.684091,
    transform: "rotate(180 527.435 123.82)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 534.276,
    cy: 123.82,
    r: 0.684091,
    transform: "rotate(180 534.276 123.82)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554.798,
    cy: 123.82,
    r: 0.684091,
    transform: "rotate(180 554.798 123.82)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.4116,
    cy: 130.661,
    r: 0.684091,
    transform: "rotate(180 55.4116 130.661)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.0933,
    cy: 130.661,
    r: 0.684091,
    transform: "rotate(180 69.0933 130.661)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.4575,
    cy: 130.661,
    r: 0.684091,
    transform: "rotate(180 96.4575 130.661)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 136.818 131.345)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 143.659 131.345)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 157.342 131.345)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 191.546 131.345)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.776,
    cy: 130.661,
    r: 0.684091,
    transform: "rotate(180 383.776 130.661)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.617,
    cy: 130.661,
    r: 0.684091,
    transform: "rotate(180 390.617 130.661)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 396.773 131.345)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 410.455 131.345)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 417.296 131.345)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 485.705 131.345)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 492.546 131.345)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 506.228 131.345)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554.798,
    cy: 130.661,
    r: 0.684091,
    transform: "rotate(180 554.798 130.661)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.639,
    cy: 130.661,
    r: 0.684091,
    transform: "rotate(180 561.639 130.661)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 568.48,
    cy: 130.661,
    r: 0.684091,
    transform: "rotate(180 568.48 130.661)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.8892,
    cy: 137.502,
    r: 0.684091,
    transform: "rotate(180 34.8892 137.502)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 88.9326 138.186)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 102.614 138.186)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 109.455 138.186)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 116.296 138.186)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 123.137 138.186)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 136.818 138.186)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 184.705 138.186)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 198.387 138.186)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.276,
    cy: 137.502,
    r: 0.684091,
    transform: "rotate(180 233.276 137.502)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.935,
    cy: 137.502,
    r: 0.684091,
    transform: "rotate(180 376.935 137.502)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.776,
    cy: 137.502,
    r: 0.684091,
    transform: "rotate(180 383.776 137.502)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.617,
    cy: 137.502,
    r: 0.684091,
    transform: "rotate(180 390.617 137.502)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 403.614 138.186)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 410.455 138.186)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 424.137 138.186)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 451.501 138.186)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 472.023 138.186)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 506.228 138.186)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 513.068 138.186)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 533.592 138.186)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 540.433 138.186)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554.798,
    cy: 137.502,
    r: 0.684091,
    transform: "rotate(180 554.798 137.502)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.73,
    cy: 144.343,
    r: 0.684091,
    transform: "rotate(180 41.73 144.343)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5708,
    cy: 144.343,
    r: 0.684091,
    transform: "rotate(180 48.5708 144.343)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.9351,
    cy: 144.343,
    r: 0.684091,
    transform: "rotate(180 75.9351 144.343)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.7759,
    cy: 144.343,
    r: 0.684091,
    transform: "rotate(180 82.7759 144.343)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.139,
    cy: 144.343,
    r: 0.684091,
    transform: "rotate(180 110.139 144.343)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.98,
    cy: 144.343,
    r: 0.684091,
    transform: "rotate(180 116.98 144.343)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.502,
    cy: 144.343,
    r: 0.684091,
    transform: "rotate(180 137.502 144.343)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.389,
    cy: 144.343,
    r: 0.684091,
    transform: "rotate(180 185.389 144.343)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.23,
    cy: 144.343,
    r: 0.684091,
    transform: "rotate(180 192.23 144.343)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.071,
    cy: 144.343,
    r: 0.684091,
    transform: "rotate(180 199.071 144.343)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 232.592 145.027)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.093,
    cy: 144.343,
    r: 0.684091,
    transform: "rotate(180 370.093 144.343)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.935,
    cy: 144.343,
    r: 0.684091,
    transform: "rotate(180 376.935 144.343)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.98,
    cy: 144.343,
    r: 0.684091,
    transform: "rotate(180 417.98 144.343)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.662,
    cy: 144.343,
    r: 0.684091,
    transform: "rotate(180 431.662 144.343)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 452.185,
    cy: 144.343,
    r: 0.684091,
    transform: "rotate(180 452.185 144.343)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.867,
    cy: 144.343,
    r: 0.684091,
    transform: "rotate(180 465.867 144.343)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.708,
    cy: 144.343,
    r: 0.684091,
    transform: "rotate(180 472.708 144.343)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 479.548,
    cy: 144.343,
    r: 0.684091,
    transform: "rotate(180 479.548 144.343)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 513.068 145.027)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 533.592 145.027)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 554.114 145.027)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 560.955 145.027)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 61.5684 151.868)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 75.251 151.868)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.867,
    cy: 151.184,
    r: 0.684091,
    transform: "rotate(180 164.867 151.184)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.23,
    cy: 151.184,
    r: 0.684091,
    transform: "rotate(180 192.23 151.184)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 212.068 151.868)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.935,
    cy: 151.184,
    r: 0.684091,
    transform: "rotate(180 376.935 151.184)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 389.933 151.868)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 396.773 151.868)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 410.455 151.868)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 417.296 151.868)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 527.435,
    cy: 151.184,
    r: 0.684091,
    transform: "rotate(180 527.435 151.184)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.958,
    cy: 151.184,
    r: 0.684091,
    transform: "rotate(180 547.958 151.184)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554.798,
    cy: 151.184,
    r: 0.684091,
    transform: "rotate(180 554.798 151.184)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.639,
    cy: 151.184,
    r: 0.684091,
    transform: "rotate(180 561.639 151.184)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 568.48,
    cy: 151.184,
    r: 0.684091,
    transform: "rotate(180 568.48 151.184)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 157.342 158.709)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 184.705 158.709)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.593,
    cy: 158.025,
    r: 0.684091,
    transform: "rotate(180 219.593 158.025)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.435,
    cy: 158.025,
    r: 0.684091,
    transform: "rotate(180 226.435 158.025)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.276,
    cy: 158.025,
    r: 0.684091,
    transform: "rotate(180 233.276 158.025)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.776,
    cy: 158.025,
    r: 0.684091,
    transform: "rotate(180 383.776 158.025)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.458,
    cy: 158.025,
    r: 0.684091,
    transform: "rotate(180 397.458 158.025)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.298,
    cy: 158.025,
    r: 0.684091,
    transform: "rotate(180 404.298 158.025)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.98,
    cy: 158.025,
    r: 0.684091,
    transform: "rotate(180 417.98 158.025)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.821,
    cy: 158.025,
    r: 0.684091,
    transform: "rotate(180 424.821 158.025)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.662,
    cy: 158.025,
    r: 0.684091,
    transform: "rotate(180 431.662 158.025)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 554.114 158.709)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 41.0459 165.55)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 54.7275 165.55)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 61.5684 165.55)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.821,
    cy: 164.866,
    r: 0.684091,
    transform: "rotate(180 123.821 164.866)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.343,
    cy: 164.866,
    r: 0.684091,
    transform: "rotate(180 144.343 164.866)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.185,
    cy: 164.866,
    r: 0.684091,
    transform: "rotate(180 151.185 164.866)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.867,
    cy: 164.866,
    r: 0.684091,
    transform: "rotate(180 164.867 164.866)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.389,
    cy: 164.866,
    r: 0.684091,
    transform: "rotate(180 185.389 164.866)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.593,
    cy: 164.866,
    r: 0.684091,
    transform: "rotate(180 219.593 164.866)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 225.751 165.55)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 369.409 165.55)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 383.092 165.55)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 389.933 165.55)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 396.773 165.55)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 403.614 165.55)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 410.455 165.55)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 417.296 165.55)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.662,
    cy: 164.866,
    r: 0.684091,
    transform: "rotate(180 431.662 164.866)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 452.185,
    cy: 164.866,
    r: 0.684091,
    transform: "rotate(180 452.185 164.866)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.026,
    cy: 164.866,
    r: 0.684091,
    transform: "rotate(180 459.026 164.866)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.708,
    cy: 164.866,
    r: 0.684091,
    transform: "rotate(180 472.708 164.866)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 493.23,
    cy: 164.866,
    r: 0.684091,
    transform: "rotate(180 493.23 164.866)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 513.752,
    cy: 164.866,
    r: 0.684091,
    transform: "rotate(180 513.752 164.866)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 541.117,
    cy: 164.866,
    r: 0.684091,
    transform: "rotate(180 541.117 164.866)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 54.7275 172.391)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 88.9326 172.391)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 102.614 172.391)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 116.296 172.391)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.662,
    cy: 171.707,
    r: 0.684091,
    transform: "rotate(180 130.662 171.707)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.343,
    cy: 171.707,
    r: 0.684091,
    transform: "rotate(180 144.343 171.707)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.185,
    cy: 171.707,
    r: 0.684091,
    transform: "rotate(180 151.185 171.707)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.026,
    cy: 171.707,
    r: 0.684091,
    transform: "rotate(180 158.026 171.707)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.708,
    cy: 171.707,
    r: 0.684091,
    transform: "rotate(180 171.708 171.707)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.23,
    cy: 171.707,
    r: 0.684091,
    transform: "rotate(180 192.23 171.707)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.071,
    cy: 171.707,
    r: 0.684091,
    transform: "rotate(180 199.071 171.707)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.752,
    cy: 171.707,
    r: 0.684091,
    transform: "rotate(180 212.752 171.707)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.593,
    cy: 171.707,
    r: 0.684091,
    transform: "rotate(180 219.593 171.707)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.435,
    cy: 171.707,
    r: 0.684091,
    transform: "rotate(180 226.435 171.707)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 369.409 172.391)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 376.251 172.391)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 383.092 172.391)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 410.455 172.391)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 417.296 172.391)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 437.818 172.391)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 452.185,
    cy: 171.707,
    r: 0.684091,
    transform: "rotate(180 452.185 171.707)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.026,
    cy: 171.707,
    r: 0.684091,
    transform: "rotate(180 459.026 171.707)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.867,
    cy: 171.707,
    r: 0.684091,
    transform: "rotate(180 465.867 171.707)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 479.548,
    cy: 171.707,
    r: 0.684091,
    transform: "rotate(180 479.548 171.707)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506.912,
    cy: 171.707,
    r: 0.684091,
    transform: "rotate(180 506.912 171.707)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 82.0918 179.232)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 109.455 179.232)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.821,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 123.821 178.548)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.662,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 130.662 178.548)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.502,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 137.502 178.548)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.343,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 144.343 178.548)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.185,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 151.185 178.548)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.867,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 164.867 178.548)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.708,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 171.708 178.548)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.548,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 178.548 178.548)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.389,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 185.389 178.548)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.071,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 199.071 178.548)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.593,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 219.593 178.548)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.276,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 233.276 178.548)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.798,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 253.798 178.548)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.639,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 260.639 178.548)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 280.478 179.232)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 294.159 179.232)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 314.683 179.232)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 321.523 179.232)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 335.205 179.232)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 348.887 179.232)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 355.728 179.232)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 362.568 179.232)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.458,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 397.458 178.548)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.821,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 424.821 178.548)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.662,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 431.662 178.548)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.343,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 445.343 178.548)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 452.185,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 452.185 178.548)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.867,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 465.867 178.548)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 479.548,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 479.548 178.548)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500.071,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 500.071 178.548)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520.593,
    cy: 178.548,
    r: 0.684091,
    transform: "rotate(180 520.593 178.548)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 526.751 179.232)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.0933,
    cy: 185.389,
    r: 0.684091,
    transform: "rotate(180 69.0933 185.389)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.9351,
    cy: 185.389,
    r: 0.684091,
    transform: "rotate(180 75.9351 185.389)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.7759,
    cy: 185.389,
    r: 0.684091,
    transform: "rotate(180 82.7759 185.389)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.4575,
    cy: 185.389,
    r: 0.684091,
    transform: "rotate(180 96.4575 185.389)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.821,
    cy: 185.389,
    r: 0.684091,
    transform: "rotate(180 123.821 185.389)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.502,
    cy: 185.389,
    r: 0.684091,
    transform: "rotate(180 137.502 185.389)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.185,
    cy: 185.389,
    r: 0.684091,
    transform: "rotate(180 151.185 185.389)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.867,
    cy: 185.389,
    r: 0.684091,
    transform: "rotate(180 164.867 185.389)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 177.864 186.073)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 184.705 186.073)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 205.228 186.073)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 212.068 186.073)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 239.433 186.073)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 246.273 186.073)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 273.637 186.073)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 294.159 186.073)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.367,
    cy: 185.389,
    r: 0.684091,
    transform: "rotate(180 315.367 185.389)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.208,
    cy: 185.389,
    r: 0.684091,
    transform: "rotate(180 322.208 185.389)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.048,
    cy: 185.389,
    r: 0.684091,
    transform: "rotate(180 329.048 185.389)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.73,
    cy: 185.389,
    r: 0.684091,
    transform: "rotate(180 342.73 185.389)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.412,
    cy: 185.389,
    r: 0.684091,
    transform: "rotate(180 356.412 185.389)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.252,
    cy: 185.389,
    r: 0.684091,
    transform: "rotate(180 363.252 185.389)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.093,
    cy: 185.389,
    r: 0.684091,
    transform: "rotate(180 370.093 185.389)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.935,
    cy: 185.389,
    r: 0.684091,
    transform: "rotate(180 376.935 185.389)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 437.818 186.073)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 451.501 186.073)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 472.023 186.073)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 485.705 186.073)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 499.387 186.073)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 506.228 186.073)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 519.909 186.073)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 526.751 186.073)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.2524,
    cy: 192.23,
    r: 0.684091,
    transform: "rotate(180 62.2524 192.23)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.7759,
    cy: 192.23,
    r: 0.684091,
    transform: "rotate(180 82.7759 192.23)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.98,
    cy: 192.23,
    r: 0.684091,
    transform: "rotate(180 116.98 192.23)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.821,
    cy: 192.23,
    r: 0.684091,
    transform: "rotate(180 123.821 192.23)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 136.818 192.914)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 143.659 192.914)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 150.501 192.914)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 157.342 192.914)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 164.183 192.914)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 177.864 192.914)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 184.705 192.914)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 198.387 192.914)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 212.068 192.914)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 225.751 192.914)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 232.592 192.914)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 253.114 192.914)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 259.955 192.914)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 266.796 192.914)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 287.318 192.914)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 294.159 192.914)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 301.001 192.914)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 314.683 192.914)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.208,
    cy: 192.23,
    r: 0.684091,
    transform: "rotate(180 322.208 192.23)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.048,
    cy: 192.23,
    r: 0.684091,
    transform: "rotate(180 329.048 192.23)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.412,
    cy: 192.23,
    r: 0.684091,
    transform: "rotate(180 356.412 192.23)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.093,
    cy: 192.23,
    r: 0.684091,
    transform: "rotate(180 370.093 192.23)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.776,
    cy: 192.23,
    r: 0.684091,
    transform: "rotate(180 383.776 192.23)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.617,
    cy: 192.23,
    r: 0.684091,
    transform: "rotate(180 390.617 192.23)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.139,
    cy: 192.23,
    r: 0.684091,
    transform: "rotate(180 411.139 192.23)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.821,
    cy: 192.23,
    r: 0.684091,
    transform: "rotate(180 424.821 192.23)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.662,
    cy: 192.23,
    r: 0.684091,
    transform: "rotate(180 431.662 192.23)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.502,
    cy: 192.23,
    r: 0.684091,
    transform: "rotate(180 438.502 192.23)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445.343,
    cy: 192.23,
    r: 0.684091,
    transform: "rotate(180 445.343 192.23)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 452.185,
    cy: 192.23,
    r: 0.684091,
    transform: "rotate(180 452.185 192.23)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 465.183 192.914)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 472.023 192.914)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 478.864 192.914)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 485.705 192.914)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 506.228 192.914)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 519.909 192.914)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 526.751 192.914)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 533.592 192.914)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 540.433 192.914)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 61.5684 199.755)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 75.251 199.755)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 88.9326 199.755)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 109.455 199.755)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.662,
    cy: 199.07,
    r: 0.684091,
    transform: "rotate(180 130.662 199.07)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.343,
    cy: 199.07,
    r: 0.684091,
    transform: "rotate(180 144.343 199.07)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.026,
    cy: 199.07,
    r: 0.684091,
    transform: "rotate(180 158.026 199.07)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.548,
    cy: 199.07,
    r: 0.684091,
    transform: "rotate(180 178.548 199.07)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.071,
    cy: 199.07,
    r: 0.684091,
    transform: "rotate(180 199.071 199.07)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.912,
    cy: 199.07,
    r: 0.684091,
    transform: "rotate(180 205.912 199.07)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.435,
    cy: 199.07,
    r: 0.684091,
    transform: "rotate(180 226.435 199.07)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.276,
    cy: 199.07,
    r: 0.684091,
    transform: "rotate(180 233.276 199.07)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.639,
    cy: 199.07,
    r: 0.684091,
    transform: "rotate(180 260.639 199.07)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.48,
    cy: 199.07,
    r: 0.684091,
    transform: "rotate(180 267.48 199.07)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.162,
    cy: 199.07,
    r: 0.684091,
    transform: "rotate(180 281.162 199.07)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.002,
    cy: 199.07,
    r: 0.684091,
    transform: "rotate(180 288.002 199.07)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.843,
    cy: 199.07,
    r: 0.684091,
    transform: "rotate(180 294.843 199.07)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 321.523 199.755)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 328.364 199.755)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 355.728 199.755)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 362.568 199.755)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 383.092 199.755)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 396.773 199.755)",
    fill: "#21335D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 417.296 199.755)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 437.818 199.755)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 451.501 199.755)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 458.342 199.755)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 465.183 199.755)",
    fill: "#21335D",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 478.864 199.755)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 485.705 199.755)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.684091,
    cy: 0.684091,
    r: 0.684091,
    transform: "matrix(1 0 0 -1 499.387 199.755)",
    fill: "#21335D",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520.593,
    cy: 199.07,
    r: 0.684091,
    transform: "rotate(180 520.593 199.07)",
    fill: "#21335D",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 534.276,
    cy: 199.07,
    r: 0.684091,
    transform: "rotate(180 534.276 199.07)",
    fill: "#21335D",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.2 108.087H400.918C405.272 108.087 409.448 109.816 412.527 112.895L445.323 145.691C448.402 148.77 452.578 150.5 456.933 150.5H506.268C510.622 150.5 514.798 152.23 517.877 155.309L545.201 182.632C548.28 185.711 550.009 189.887 550.009 194.242V242.209C550.009 246.563 548.28 250.739 545.201 253.818L493.25 305.769C490.171 308.848 485.995 310.577 481.64 310.577H406.35",
    stroke: "#1D3E7A",
    strokeOpacity: 0.08,
    strokeWidth: 1.36818
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.764 108.087H710.046C705.692 108.087 701.516 109.816 698.437 112.895L665.641 145.691C662.562 148.77 658.386 150.5 654.031 150.5H604.696C600.342 150.5 596.166 152.23 593.087 155.309L565.763 182.632C562.684 185.711 560.955 189.887 560.955 194.242V242.209C560.955 246.563 562.684 250.739 565.763 253.818L617.714 305.769C620.793 308.848 624.969 310.577 629.323 310.577H704.614",
    stroke: "#1D3E7A",
    strokeOpacity: 0.08,
    strokeWidth: 1.36818
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.2 97.1411H400.918C405.272 97.1411 409.448 95.4113 412.527 92.3323L445.323 59.5362C448.402 56.4572 452.578 54.7275 456.933 54.7275H506.268C510.622 54.7275 514.798 52.9977 517.877 49.9187L545.201 22.5953C548.28 19.5163 550.009 15.3403 550.009 10.9859V-36.981C550.009 -41.3354 548.28 -45.5114 545.201 -48.5904L493.25 -100.541C490.171 -103.62 485.995 -105.35 481.64 -105.35H406.35",
    stroke: "#1D3E7A",
    strokeOpacity: 0.08,
    strokeWidth: 1.36818
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.8 108.087H201.082C196.728 108.087 192.552 109.816 189.473 112.895L156.677 145.691C153.598 148.77 149.422 150.5 145.067 150.5H95.7323C91.3779 150.5 87.2019 152.23 84.1228 155.309L56.7995 182.632C53.7205 185.711 51.9907 189.887 51.9907 194.242V242.209C51.9907 246.563 53.7205 250.739 56.7995 253.818L108.75 305.769C111.829 308.848 116.005 310.577 120.36 310.577H195.65",
    stroke: "#1D3E7A",
    strokeOpacity: 0.08,
    strokeWidth: 1.36818
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.764 108.087H-108.046C-103.692 108.087 -99.5157 109.816 -96.4367 112.895L-63.6406 145.691C-60.5616 148.77 -56.3856 150.5 -52.0312 150.5H-2.69612C1.65825 150.5 5.83428 152.23 8.91329 155.309L36.2366 182.632C39.3157 185.711 41.0454 189.887 41.0454 194.242V242.209C41.0454 246.563 39.3157 250.739 36.2366 253.818L-15.714 305.769C-18.793 308.848 -22.969 310.577 -27.3234 310.577H-102.614",
    stroke: "#1D3E7A",
    strokeOpacity: 0.08,
    strokeWidth: 1.36818
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.8 97.1411H201.082C196.728 97.1411 192.552 95.4113 189.473 92.3323L156.677 59.5362C153.598 56.4572 149.422 54.7275 145.067 54.7275H95.7323C91.3779 54.7275 87.2019 52.9977 84.1228 49.9187L56.7995 22.5953C53.7205 19.5163 51.9907 15.3403 51.9907 10.9859V-36.981C51.9907 -41.3354 53.7205 -45.5114 56.7995 -48.5904L108.75 -100.541C111.829 -103.62 116.005 -105.35 120.36 -105.35H195.65",
    stroke: "#1D3E7A",
    strokeOpacity: 0.08,
    strokeWidth: 1.36818
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.2 108.087H400.918C405.272 108.087 409.448 109.816 412.527 112.895L445.323 145.691C448.402 148.77 452.578 150.5 456.933 150.5H506.268C510.622 150.5 514.798 152.23 517.877 155.309L545.201 182.632C548.28 185.711 550.009 189.887 550.009 194.242V242.209C550.009 246.563 548.28 250.739 545.201 253.818L493.25 305.769C490.171 308.848 485.995 310.577 481.64 310.577H406.35",
    stroke: "url(#paint2_linear_3142_36165)",
    strokeWidth: 1.36818,
    strokeLinecap: "round",
    strokeDasharray: "0.01 4.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.8 108.087H201.082C196.728 108.087 192.552 109.816 189.473 112.895L156.677 145.691C153.598 148.77 149.422 150.5 145.067 150.5H95.7323C91.3779 150.5 87.2019 152.23 84.1228 155.309L56.7995 182.632C53.7205 185.711 51.9907 189.887 51.9907 194.242V242.209C51.9907 246.563 53.7205 250.739 56.7995 253.818L108.75 305.769C111.829 308.848 116.005 310.577 120.36 310.577H195.65",
    stroke: "url(#paint3_linear_3142_36165)",
    strokeWidth: 1.36818,
    strokeLinecap: "round",
    strokeDasharray: "0.01 4.1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3142_36165",
    x1: 301,
    y1: -6.84082,
    x2: 301,
    y2: 227.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727528,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3142_36165",
    x1: 0.00000224262,
    y1: 97.8251,
    x2: 602,
    y2: 97.8251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0818182,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934091,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3142_36165",
    x1: 367.382,
    y1: 99.1573,
    x2: 322.238,
    y2: 21.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3E7A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#1D3E7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D3E7A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3142_36165",
    x1: 240.806,
    y1: 101.931,
    x2: 307.846,
    y2: 8.21272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3E7A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#1D3E7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D3E7A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3142_36165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 602,
    height: 218.909,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.13232dda1a07e018caa9bc2ea5b62c55.svg";
export { ForwardRef as ReactComponent };